module.exports = __webpack_public_path__ + "media/images/vp/samples/28-6f0f18211df0ab7aff9cb7455423434c.jpg";